var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.938 4H6.983C5.365 4 4 5.365 4 7v9c0 1.635 1.365 3 3 3h10.87c1.619 0 3-1.365 3-3V7c.068-1.635-1.297-3-2.932-3zm1.197 12.084c0 .691-.506 1.281-1.197 1.281H6.983c-.69 0-1.28-.607-1.28-1.28V7c0-.691.606-1.28 1.28-1.28h10.87c.692 0 1.282.606 1.282 1.28v9.084z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.404 6.916c-.337 0-.69.168-.943.421s-.337.523-.337.86c0 .69.606 1.28 1.28 1.28.675 0 1.281-.606 1.281-1.28 0-.675-.606-1.281-1.28-1.281zM15.376 10.421c-.252-.606-1.112-.69-1.533-.168l-1.113 1.635a.866.866 0 01-1.45 0l-.336-.422c-.337-.522-1.113-.421-1.45.085l-1.904 3c-.337.606 0 1.365.775 1.365h8.04c.606 0 1.028-.691.775-1.281l-1.804-4.214z"
  })));
}

export default SvgImage;